module.exports = __webpack_public_path__ + "static/media/fastai_logo.032507ed.png";